module.exports = __webpack_public_path__ + "img/segudigital-actual-logo.a1d94d11.png";